import { Injectable } from "@angular/core"
import { environment } from "src/environments/environment"
import { AppService } from "src/app/core/services/app.service"
import { map } from "rxjs/operators"
import { HttpClient, HttpHeaders } from "@angular/common/http"

@Injectable({
  providedIn: "root",
})
export class HandleFileService {
  private get_export_url: string

  private headerAuth: HttpHeaders

  private buildUrls(exportUrl: string) {
    this.get_export_url =
      exportUrl + environment.endpointSchoolClass.routes.get_export
  }

  constructor(private oHttp: HttpClient, private appService: AppService) {
    this.headerAuth = new HttpHeaders({
      Authorization:
        "Bearer " +
        (this.appService.currentUser != null
          ? this.appService.currentUser.accessToken
          : "aa"),
      "x-intercept-error": "true",
    })
    this.buildUrls(environment.endpointSchoolClass.url)
  }

  exportUsers(schoolId: string, countryType: number) {
    return this.oHttp.get(
      `${this.get_export_url.replace(
        "{schoolId}",
        schoolId
      )}?countryType=${countryType}`,
      {
        headers: this.headerAuth,
      }
    )
  }

  lexExportUsers(schoolId, countryType: number) {
    return this.oHttp.get(
      `${this.get_export_url
        .replace("/export/", "/lexexport/")
        .replace("{schoolId}", schoolId)}?countryType=${countryType}`,
      { headers: this.headerAuth }
    )
  }
}
